<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>            
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md12 class="pr-4">
                    <v-autocomplete
                      label="Asset Name *"
                      :item-text="item => item.asset_name +' -- ('+ item.asset_code+')'"
                      item-value="id"
                      v-model="formSchema.asset_id"
                      :items="assetName"
                      :rules="[v => !!v || 'Field is required']"
                      @change="setAssetCode"
                    ></v-autocomplete>
                    <input type="hidden" v-model="formSchema.asset_code" />
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-autocomplete
                      label="Current Location *"
                      item-text="location_name"
                      item-value="id"
                      v-model="formSchema.asset_location_id"
                      :items="assetLocation"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-autocomplete
                      label="Current User Name"
                      item-text="employee_name"
                      item-value="id"
                      v-model="formSchema.employee_id"
                      :items="employeeName"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4" v-if="is_data">
                    <v-autocomplete
                      label="New Location"
                      item-text="location_name"
                      item-value="id"
                      v-model="formSchema.new_asset_location_id"
                      :items="assetLocation"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4" v-if="is_data">
                    <v-autocomplete
                      label="New User Name"
                      item-text="employee_name"
                      item-value="id"
                      v-model="formSchema.new_employee_id"
                      :items="employeeName"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'issue_date', fieldValue:formSchema.issue_date, label:'Issue Date *', required:1}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'close_date', fieldValue:formSchema.close_date, label:'Close Date *', required:''}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-autocomplete
                      label="Movement Status *"
                      item-text="issue_title"
                      item-value="id"
                      v-model="formSchema.issue_status"
                      :items="issueStatus"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-autocomplete
                      label="Asset Status *"
                      item-text="title"
                      item-value="id"
                      v-model="formSchema.asset_status"
                      :items="assetStatus"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
              
              <v-btn class="info" flat @click.native="close({message:'Form Reseted !',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  components: {
    DatePicker
  },

  props: ["formSchema","is_data"],

  data: () => ({
    show: false,
    valid: true,
    assetLocation: [],
    assetSubCats: [], // asset sub categories
    assetName: [], // Asset name collection
    employeeName: [], // User name collection
    assetStatus: [], // asset status collection
    issueStatus: [] // Issue Status
  }),

  // Page Load After Called Mathodes =========================================
  computed: {
    formTitle() {
      // From title As Action
      return this.formSchema.id > 0
        ? "Edit Assets Issue/ Reissue/ Movement"
        : "Add Assets Issue/ Reissue/ Movement";
    },
    buttonTitle() {
      // Button title As Action
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  // Page Load Before Called Mathodes =========================================
  created() {
    this.loadData();
    let root = this;
    commonService.getAllData("get-role-list").then(res => {
      root.roleList = res.roleList;
    });

    commonService.getAllData("asset_sub_category").then(res => {
      // Cat list for submenu
      root.assetSubCats = res.data;
    });

    commonService.getAllData("asset_location").then(res => {
      // Asset Location List
      root.assetLocation = res.data;
    });

    commonService.getAllData("get_asset_master_info").then(res => {
      // Get Asset List
      root.assetName = res.data;
    });

    commonService.getAllData("get_staff_info").then(res => {
      // Get Employeee List
      root.employeeName = res.data;
    });
    // get_asset_status Name List
    commonService.getAllData("get_asset_status").then(res => {
      root.assetStatus = res.data;
    });
    // get_asset_status Name List
    commonService.getAllData("get_asset_movement_status").then(res => {
      root.issueStatus = res.data;
    });
  },

  // Declared Methods for reuse====================================
  methods: {
    validateBeforeSubmit(e) {
      // Form submission function
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;
      formSchema.issue_date = root.changeFormateYMD(this.formSchema.issue_date);
      formSchema.close_date = root.changeFormateYMD(this.formSchema.close_date);

      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_movement")
            .then(res => {
              res.action = "edit";
              this.close(res);
            });
        } else {
          //console.log(formSchema); // Form submission function Update
          commonService
            .insertFormData(this.formSchema, "asset_movement")
            .then(res => {
              res.action = "add";
              this.close(res);
            });
        }
      }
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    loadData() {
      this.show = true;
    },

    setAssetCode() {
      // Data Empty 
      this.formSchema.asset_location_id ='';
      this.formSchema.employee_id = '';
      this.is_data = false;
      // onchange Asset name get asset Code
      var asset_id = this.formSchema.asset_id;
      var index = this.assetName
        .map(function(e) {
          return e.id;
        })
        .indexOf(asset_id);
      var asset_code = this.assetName[index].asset_code;
      var asset_location = this.assetName[index].asset_location;
      this.formSchema.asset_code = asset_code;

      commonService.getAllDataById(asset_id,"get_asset_master_dynamic").then(res => {
        
        // Get Asset List
        if(res.is_data == true){ 
          this.is_data = res.is_data;
          if(res.data.new_asset_location_id == null){ 
            this.formSchema.asset_location_id = res.data.asset_location_id;
            this.formSchema.employee_id = res.data.employee_id;
          }else{
            this.formSchema.asset_location_id = res.data.new_asset_location_id;
            this.formSchema.employee_id = res.data.new_employee_id;
          }         
        } else{
            this.formSchema.asset_location_id = asset_location;
            this.formSchema.new_employee_id = 900000;
        }       //root.assetName = res.data;
        
      });
      //console.log(this.formSchema.new_employee_id);
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {

        let formSchema = this.formSchema;
        formSchema.issue_date =''
        formSchema.close_date =''

        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/asset/asset_movement/asset_movement_form.vue